import { Message } from '../../../type';
import React, { useCallback, useContext } from 'react';
import { format } from 'date-fns';
import { Box, IconButton, ListItem, ListItemText } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Warning';
import RetryIcon from '@mui/icons-material/Replay';
import { MediaErrorMessageAwareContext } from './MediaErrorMessageAware';

type MyMediaErrorMessageProps = {
  message: Message;
};

export const MyMediaErrorMessage = React.forwardRef<
  HTMLLIElement,
  MyMediaErrorMessageProps
>((props, ref) => {
  const formattedTime = format(props.message.createdDate.toDate(), 'HH:mm a');
  const errorAwareContext = useContext(MediaErrorMessageAwareContext);
  const reloadMessage = useCallback(() => {
    if (errorAwareContext) {
      errorAwareContext.retry();
    }
  }, [errorAwareContext]);
  return (
    <ListItem
      ref={ref}
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'flex-end',
        flexDirection: 'column',
        py: 2,
        px: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          flexDirection: 'row-reverse',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
          width: '100%',
        }}
      >
        <ListItemText
          sx={{ flex: 'unset' }}
          primary={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                borderRadius: 3,
                width: 200,
                height: 112.5,
                bgcolor: '#444',
              }}
            >
              <IconButton
                sx={{ position: 'absolute', alignSelf: 'center', p: 3 }}
                onClick={reloadMessage}
              >
                <RetryIcon sx={{ color: 'white', width: 32, height: 32 }} />
              </IconButton>
            </Box>
          }
          primaryTypographyProps={{ component: 'div' }}
        />
        <ListItemText
          sx={{ flexShrink: 0 }}
          secondary={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <ErrorIcon
                sx={{ with: 20, height: 20, color: '#d00070', mb: 2.5 }}
              />
              <Box sx={{ textAlign: 'end', pr: 2.5, color: '#898f9b' }}>
                {formattedTime}
              </Box>
            </Box>
          }
          secondaryTypographyProps={{
            component: 'div',
            width: 'fit-content',
            ml: 'auto',
          }}
        />
      </Box>
    </ListItem>
  );
});

MyMediaErrorMessage.displayName = 'MyMediaErrorMessage';
